import React from "react";
import { css } from "@emotion/css";

const overlayStyle = css`
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1000;
`;

const dialogStyle = css`
    background-color: white;
    border-radius: 8px;
    padding: 24px;
    width: 90%;
    max-width: 400px;
    box-shadow: 0 4px 6px rgba(0,0,0,0.1);
`;

const titleStyle = css`
    color: #3f51b5;
    text-align: center;
    font-size: 22px;
    margin-top: 0;
    margin-bottom: 16px;
    font-weight: 600;
`;

const textStyle = css`
    font-size: 16px;
    white-space: pre-wrap;
    color: #263238;
    margin-bottom: 16px;
    line-height: 1.5;
    font-weight: 600;
`;

const actionsStyle = css`
    display: flex;
    justify-content: center;
    gap: 12px;
    margin-top: 24px;
`;

const buttonStyle = (bg) => css`
    padding: 8px 16px;
    border-radius: 4px;
    font-size: 14px;
    font-weight: 600;
    cursor: pointer;
    border: none;
    color: white;
    background-color: ${bg};
    min-width: 80px;
    text-align: center;
    text-decoration: none;
    display: inline-block;
`;

export const WhatsappJoinDialog = ({
    show,
    primaryMsg,
    secondaryMsg,
    whatsappLink,
    onCloseHandler,
}) => {
    if (!show) return null;

    return (
        <div className={overlayStyle}>
            <div className={dialogStyle}>
                <h2 className={titleStyle}>Join Whatsapp Group</h2>
                <div>
                    <p className={textStyle}>{primaryMsg}</p>
                    <p className={textStyle}>{secondaryMsg}</p>
                </div>
                <div className={actionsStyle}>
                    <button
                        className={buttonStyle("#78909c")}
                        onClick={onCloseHandler}
                    >
                        Cancel
                    </button>
                    <a
                        className={buttonStyle("#29b6f6")}
                        href={whatsappLink}
                        target="_blank"
                        rel="noreferrer"
                        onClick={onCloseHandler}
                        style={{ width: "100px" }}
                    >
                        Join
                    </a>
                </div>
            </div>
        </div>
    );
};

export default WhatsappJoinDialog;
